import { createSlice } from "@reduxjs/toolkit";
import { IStudentHelpSlice } from "../../../models/master/studentHelp";


const initialStudentHelpState: IStudentHelpSlice = {
  studentHelps:undefined,
  studentHelp:undefined
};

const studentHelpSlice = createSlice({
  name: "studentHelp",
  initialState: initialStudentHelpState,
  reducers: {
    setStudentHelps: (state, action: { payload: any }) => {
      state.studentHelps = action.payload;
    },
    setStudentHelp: (state, action: { payload: any }) => {
      state.studentHelp = action.payload;
    },
    
  },
});

export const { setStudentHelps,setStudentHelp } =
studentHelpSlice.actions;

const studentHelpReducer = studentHelpSlice.reducer;

export type studentHelpState = ReturnType<typeof studentHelpReducer>;

export default studentHelpReducer;
